<template>
  <panel title="" class="mgb10">
    <div class="center font18">升级专业版，使用简赢完整解决方案</div>
    <ol class="ol">
      <li>门店进销存管理、网店平台及快递对接、多渠道分销管理等</li>
      <li>
        销售单、定制单、租赁单，流程化系统协同处理；客户档案管理、预约管理、租赁档期管理、产品资料管理等
      </li>
      <li>多流程处理：自有工厂生产、下单给合作供应商、匹配库存现货处理等</li>
      <li>生产管理：生产进度实时追踪、计件工资结算、生产计划计算等</li>
      <li>物料管理：物料采购、订单算料、物料仓扣减</li>
      <li>
        财务报表：销售、生产、采购、物流等各方结算对账及各版块数据报表分析等
      </li>
      <li>
        授权管理：子账号数据及操作权限设置、多部门各角色分解系统化协同配合工作
      </li>
      <li>
        可根据不同类型企业需求自定义工作流程和常规系统参数，提供更实用的解决方案
      </li>
      <div class="mgt10">
        <span class="strong font16">咨询热线：</span>
        <ul>
          <li>苏州服务中心：15850222652（微信同号）</li>
          <li>广州服务中心：13381630357（微信同号）</li>
          <li>潮州服务中心：13381630357（微信同号）</li>
          <li>其他地区： 13381630357（微信同号）</li>
        </ul>
      </div>
    </ol>
  </panel>
</template>

<script>
export default {
  data() {
    return {};
  },

  created() {},
  methods: {},
};
</script>
<style scoped>
.ol {
  /* list-style: none; */
}
.ol li {
  line-height: 40px;
}
</style>